module.exports = __webpack_public_path__ + "media/images/emblems/Bas-Intyamon-coat_of_arms-8154f2d6b7d090c4744bb0b2032d7f79.svg";